module.exports = __webpack_public_path__ + "static/img/zhinengzhizao-3.66696ae3.svg";